/*=========================================================================================
  File Name: getters.js
  Description: Vuex Store - getters
  ----------------------------------------------------------------------------------------
  Item Name: Pre-Pulse
  
==========================================================================================*/

// added so later we can keep breakpoint in sync automatically using this config file
// import tailwindConfig from "../../tailwind.config.js"

const getters = {

  // COMPONENT
  // vx-autosuggest
  // starredPages: state => state.navbarSearchAndPinList.data.filter((page) => page.highlightAction),
  windowBreakPoint: state => {

    // This should be same as tailwind. So, it stays in sync with tailwind utility classes
    if (state.windowWidth >= 1200) return 'xl'
    else if (state.windowWidth >= 992) return 'lg'
    else if (state.windowWidth >= 768) return 'md'
    else if (state.windowWidth >= 576) return 'sm'
    else return 'xs'
  },
  scrollbarTag: state => {
    return state.is_touch_device ? 'div' : 'VuePerfectScrollbar'
  },
  GetUserInfo : state => {
    return state.userInfo
  },
  GetMyUserName : state => {
    return state.userInfo.UserName.replace(".", " ")
  },
  GetInPrePulse : state => {
    return state.inPrePulse
  }, 
  GetAlertModal : state => {
    return state.modals['AlertModal']
  },
  GetFileUploadModal : state => {
    return state.modals['FileUploadModal']
  },
  GetSelectedClientID: state => {
    return state.selectedClientID
  },
  GetClientSet: state => {
    return state.clientSet
  },
  GetIsAuthorized : state => {
    return state.isAuthorized
  },
  GetObjectSecurity : state => (fieldName) => {

    var cachedResult = state.cachedObjectSecurities[fieldName]
    if(cachedResult != null)
    {
      return cachedResult
    }
    var result = {
      fieldName: fieldName,
      objectSecurityHidden: false,
      objectSecurityDisabled: false
    }

    var securityObject = state.securityObjectList.find(x => x.ObjectName == fieldName)
    if(securityObject != null){
      var securityObjectID = securityObject.ObjectID
      var objectSecurityListItem = state.objectSecurityList
      .find(x => x.SecurityObjectID == securityObjectID && x.UserSecurityCode == state.pulseUser.UserSecCode)

      if(objectSecurityListItem != null){
        if(objectSecurityListItem.Status == 1){
          result = {
            fieldName: fieldName,
            objectSecurityHidden: true,
            objectSecurityDisabled: false
          }
        }else if(objectSecurityListItem.Status == 0){
          result = {
            fieldName: fieldName,
            objectSecurityHidden: false,
            objectSecurityDisabled: true
          }
        }
      }
    }
    state.cachedObjectSecurities[fieldName] = result

    return result


  },
  
  GetLookups : state => (fieldName) => {
    return state.lookup[fieldName]
  },

  GetLastPulseRoute : state => {
    return state.lastPulseRoute
  },

  GetLastPrePulseRoute : state => {
    return state.lastPrePulseRoute
  },
  GetClientList : state => {
    return state.clientList
  },
  GetSessionEndingSoon : state => {
    return state.sessionEndingSoon
  },
  GetFileUploading : state => {
    return state.fileUploading
  }
  
}

export default getters
